import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import withRouter from '../../Utils/withRouter';
import Swal from 'sweetalert2';
import { SubmitButton, TextBox, convertTo12HourFormat, formatDate, formatTime, getHoursAndMinutes, isNegativeDeviation } from '../../Components/InputElements'
import Select from 'react-select'
import axios from "axios";
import * as XLSX from 'xlsx'
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime,decodeData, getMonthCycleStartDate, getNextMonthIfDayExceeds20 } from '../../Constants/constants';


class MyAttendanceReport extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            employee_attendance_id: 0,
            position: [19.0742113, 72.8561198],
            loadingList: false,
            postLoading: false,
            leave_type_row: [],
            leave_category_row: [],
            punch_out_address: '',
            next: false,
            prev: false,
            LeaveRows: [],
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            rows: [],
            employee_info: [],
            salaries: [],
            salaries_statutory: [],
            from_date: "",
            to_date: "",
            selectOption: "",
            month: null,
            startDay:null,
            monthOptions: [],
            punch_in_date: "",
            punch_in_time: "",
            punch_out_date: "",
            punch_out_time: "",
            display_name: "",
            city: "",
            company_location_shift_id: "",
            loadingLocation: false,
            loadingFilter: false,
            showLocation: false,
            decodedData: [],
        };
        this.attendanceLocationInfoRef = React.createRef();
    }

    async componentDidMount() {
        this.setState({ loadingList: true }, async () => {
            try {
                // await this.GetLocation();
                await this.GetMonthFilterList();
                let date= getMonthCycleStartDate(currentDateAndTime(),this.state.startDay);
                let currMonth= getNextMonthIfDayExceeds20(date);
                // console.log("componentDidMount ~ currMonth",currMonth);
                this.setState({ month:currMonth});
                await this.GetList();
            } catch (error) {
                console.error('An error occurred in component mounnting:', error);
            } finally {
                 
                this.setState({ loadingList: false });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
            console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                console.log("encodedData",encodedData);
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                console.log("decodedData",decodedData);
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
                }
            } else {
                console.warn("Permissions not yet available. Retrying...");
            }
        }
    }

    GetMonthFilterList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetMonthYearFilterList`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                if (data?.success === true) {
                    this.setState({
                        loadingList: false,
                        monthOptions: data?.filterArray

                    });
                    let filterArray = data?.filterArray;
                    // Extract current month from your logic
                    const currentMonth = parseInt(this.getCurrentMonth(), 10);

                    // Find the corresponding month option based on the current month
                    const defaultMonthOption = filterArray.find(option => parseInt(option.value.split("-")[0]) === currentMonth);

                    // Set the month in the state after monthOptions are updated
                    this.setState({
                        month: defaultMonthOption ? defaultMonthOption.value : null, // Set the default month if found
                        startDay: data?.month_cycle_start_date,
                    });

                } else {
                    this.setState({ loadingList: false });
                }
            });
    };

    scrollToDiv = () => {
        if (this.attendanceLocationInfoRef.current) {
            this.attendanceLocationInfoRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
    };

    getCurrentMonth = () => {
        const currentDate = currentDateAndTime()?.split(" ")[0]; // Extract the date part
        const currentMonth = currentDate?.split("-")[1]; // Get the month (second part)
        return currentMonth; // This should be a string representing the month (e.g., "09")
    };

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetAttendances`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                attendance_status: this.state.selectOption || "",
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                month: this.state.month,
                date: currentDateAndTime()
            }, headers
        }).then(async (response) => {
            var data = response.data;
            if (data?.response?.success === true) {

                this.setState({
                    rows: data?.response?.data,
                    next: data?.response?.next,
                    prev: data?.response?.prev,
                    page: data?.response?.page,
                    total_records: data?.response?.total_records,
                    total_pages: data?.response?.total_pages,
                    loadingList: false
                });
            }
            this.setState({ loadingList: false, loadingFilter: false });
        })
        .catch((error)=>{
            this.setState({ loadingList: false, loadingFilter: false });
            Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: error?.message, 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
            });
        });
    }
    // GetLocation = () => {
    //     this.setState({ loadingLocation: true });
    //     axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${this.state.position[0]}&lon=${this.state.position[1]}&zoom=18&addressdetails=1`).then((response) => {
    //         var data = response.data;
    //         if (response.data !== 0) {
    //             setTimeout(() => {
    //                 // Code to execute after 1 second
    //                 this.setState({
    //                     display_name: data.display_name,
    //                     city: data.address.city,
    //                     loadingLocation: false,
    //                 });
    //             }, 500);
    //         } else {
    //             this.setState({ loadingLocation: false });
    //         }
    //     });
    // }

    // showInMap = (positionString, punch_in_date, punch_in_time, punch_in_address) => {
    //     if (!positionString) {
    //         return
    //     }
    //     const positionArray = positionString.split(',').map(Number);

    //     this.setState({
    //         position: positionArray,
    //         punch_in_date: punch_in_date,
    //         punch_in_time: punch_in_time,
    //         punch_out_address: '',
    //         punch_in_address: punch_in_address,
    //         punch_out_date: null,
    //         punch_out_time: null,
    //     });
    //     this.GetLocation();
    // }
    showInMap = (positionString, punch_in_date, punch_in_time, punch_in_address, show) => {
        if (!positionString) {
            return
        }
        const positionArray = positionString.split(',').map(Number);

        this.setState({
            position: positionArray,
            showLocation: show,
            punch_in_date: punch_in_date,
            punch_in_time: punch_in_time,
            punch_out_address: '',
            punch_in_address: punch_in_address,
            punch_out_date: null,
            punch_out_time: null,
        });
        // this.GetLocation();
    }

    // showOutMap = (positionString, punch_out_date, punch_out_time, punch_out_address) => {
    //     if (!positionString) {
    //         return
    //     }
    //     const positionArray = positionString.split(',').map(Number);

    //     this.setState({
    //         position: positionArray,
    //         punch_out_date: punch_out_date,
    //         punch_out_time: punch_out_time,
    //         punch_in_address: '',
    //         punch_out_address: punch_out_address,
    //         punch_in_date: null,
    //         punch_in_time: null,
    //     });
    //     this.GetLocation();
    // }
    showOutMap = (positionString, punch_out_date, punch_out_time, punch_out_address, show) => {
        if (!positionString) {
            return
        }
        const positionArray = positionString.split(',').map(Number);

        this.setState({
            position: positionArray,
            showLocation: show,
            punch_out_date: punch_out_date,
            punch_out_time: punch_out_time,
            punch_in_address: '',
            punch_out_address: punch_out_address,
            punch_in_date: null,
            punch_in_time: null,
        });
        // this.GetLocation();
    }
    checkIsLeave = (data) => {
        const leaveFromDate = data.employee_leave_from_date;
        const leaveToDate = data.employee_leave_to_date;
        let created_datetime = data.created_date;
        const createdDate = created_datetime.split(' ')[0];

        if (data.employee_leave_id) {
            if (createdDate === leaveFromDate) {
                return data.employee_leave_from_day_unit === "First Half" ? ' / 1' : data.employee_leave_from_day_unit === "Second Half" ? ' / 2' : '';
            }
            if (createdDate === leaveToDate) {
                return data.employee_leave_to_day_unit === "First Half" ? ' / 1' : data.employee_leave_from_day_unit === "Second Half" ? ' / 2' : '';
            }
        } else {
            return '';
        }
    }
    calculateWorkingHours = (data) => {
        let shiftStart = data?.ShiftStart;
        let shiftEnd = data?.ShiftEnd;
        let punchIn = data?.PunchIn?.split(" ")[1]
        let punchOut = data?.PunchOut?.split(" ")[1]
        if (shiftStart && shiftEnd && punchIn && punchOut) {
            // Helper function to parse time strings into Date objects
            const parseTime = (timeStr) => {
                const [hours, minutes] = timeStr.split(':').map(Number);
                return new Date(0, 0, 0, hours, minutes);
            };

            // Helper function to calculate the difference in hours between two Date objects
            const calculateHoursDifference = (start, end) => {
                const millisecondsPerHour = 1000 * 60 * 60;
                return (end - start) / millisecondsPerHour;
            };

            // Parse times
            const shiftStartTime = parseTime(shiftStart);
            const shiftEndTime = parseTime(shiftEnd);
            const punchInTime = parseTime(punchIn);
            const punchOutTime = parseTime(punchOut);

            // Calculate total working hours
            let totalWorkingHours = calculateHoursDifference(shiftStartTime, shiftEndTime);

            // Calculate half of the total working hours
            const halfWorkingHours = totalWorkingHours / 2;

            // Calculate punch hours
            let punchHours = calculateHoursDifference(punchInTime, punchOutTime);
            // Compare punch hours with half of the working hours
            return punchHours >= halfWorkingHours;
        }
        else {
            return false;
        }


    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleSelectChange(name, selectedOption) {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    }

    handleInputSearch = () => {
        this.setState(
            {
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    }


    handleClearAll = () => {
        try {
             let filterArray = this.state.monthOptions;
            console.log("filterArray in clear", filterArray);
            // Extract current month from your logic
            const currentMonth = parseInt(this.getCurrentMonth(), 10);

            // Find the corresponding month option based on the current month
            const defaultMonthOption = filterArray.find(option => parseInt(option.value.split("-")[0]) === currentMonth);
            this.setState(
                {
                    rows: [],
                    next: false,
                    prev: false,
                    page: 1,
                    limit: 10,
                    total_records: 0,
                    total_pages: 0,
                    loadingList: false,
                    postLoading: false,
                    from_date: "",
                    to_date: "",
                    selectOption: "",
                    // month: `${parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1])}-${parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[0])}`,
                    // month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
                    month: defaultMonthOption ? defaultMonthOption.value : null,
                },
                () => {
                    this.GetList();
                }
            );
        } catch (error) {
            this.setState({ loadingFilter: false });
        }
       
    };

    handleExcelDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get(`${apiURL}Home/GetAttendances`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                attendance_status: this.state.selectOption || "",
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                month: this.state.month,
                date: currentDateAndTime()
            }, headers
        }).then(async (response) => {
            if (response.data?.response?.success === true) {
                const rows = response.data?.response?.data;
                const data = rows.map(row => ({
                    'Date': formatDate(row.attendance_date),
                    'Punch In': ` ${row.PunchIn ? formatDate(row.PunchIn) : ""} - ${row.PunchIn ? formatTime(row.PunchIn) : "-"}`,
                    'Punch Out': ` ${row.PunchOut ? formatDate(row.PunchOut) : ""} - ${row.PunchOut ? formatTime(row.PunchOut) : "-"}`,
                    'Shift': `${row.ShiftStart ? convertTo12HourFormat(row.ShiftStart) : ""} - ${row.ShiftEnd ? convertTo12HourFormat(row.ShiftEnd) : ""}`,
                    'Working Hours': row.WorkingHours ? getHoursAndMinutes(row.WorkingHours) : "- -",
                    // 'Deviation': row.Deviation ? getHoursAndMinutes(row.Deviation) : "- -",
                    'Attendance Status': row.AttendanceStatus ? row.AttendanceStatus : "- -",
                    // 'Action Status': row.regularizationRequestStatus ? row.regularizationRequestStatus : "- -",
                    // 'Regularization Type': row.regularizationType ? row.regularizationType : "- -",
                    // 'Reason': row.remark_by_employee ? row.remark_by_employee : "- -",
                    // 'Remark': row.remark_by_manager ? row.remark_by_manager : "- -",
                }));

                const columns = [
                    { header: 'Date', key: 'Date', width: 20 },
                    { header: 'Punch In', key: 'Punch In', width: 20 },
                    { header: 'Punch Out', key: 'Punch Out', width: 20 },
                    { header: 'Shift', key: 'Shift', width: 20 },
                    { header: 'Working Hours', key: 'Working Hours', width: 20 },
                    // { header: 'Deviation', key: 'Deviation', width: 20 },
                    { header: 'Attendance Status', key: 'Attendance Status', width: 20 },
                    // { header: 'Action Status', key: 'Action Status', width: 20 },
                    // { header: 'Regularization Type', key: 'Regularization Type', width: 20 },
                    // { header: 'Reason', key: 'Reason', width: 20 },
                    // { header: 'Remark', key: 'Remark', width: 20 },
                ];

                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });
                ws['!cols'] = columns.map(column => ({ wch: column.width }));
                XLSX.utils.book_append_sheet(wb, ws, 'AbStart My Attendance Report');

                // XLSX.writeFile(wb, `AbStartMyAttendanceReport_(${Date()}).xlsx`);

                const date = new Date();
                const dateString = date.toLocaleDateString();
                const timeString = date.toLocaleTimeString();

                XLSX.writeFile(wb, `AbStartMyAttendanceReport_(${formatDate(dateString)} ${timeString}).xlsx`);

                Swal.close();

                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success'
                });
            } else {
                Swal.close();
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error'
                });
            }
        }).catch((error) => {
            Swal.close();
            Swal.fire({
                title: '<strong>Error</strong>',
                html: error.message,
                icon: 'error'
            });
        });
    }


    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }

    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    handleLimitChange = (e) => {
        this.setState(
            {
                limit: parseInt(e.target.value, 10),
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    };

    render() {
        const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];
        const options = [
            { value: '0', label: 'Absent' },
            { value: '1', label: 'Present' },
            { value: '2', label: 'Half Day' },
            // { value: '3', label: 'Regularized' },
            // { value: '4', label: 'Auto Regularized' },
            // { value: '5', label: 'Regularization Rejected' },
            // { value: '6', label: 'Late Mark' },
            // { value: '7', label: 'Early Mark' },
            // { value: '8', label: 'Leave' },
            // { value: '9', label: 'Holiday' },
        ];

        const { loadingLocation } = this.state;
        return (
            this.state.loadingList === false ?
                (
                    <div class="main-content" >
                        <div class="page-content">
                            <div className="container-fluid">
                                <br />
                                <PageTitle title={`My Attendance Report`} primary={`My Details`} />
                                <div className='card'>
                                    <div className='card-body'>
                                        {/* <div class="card-header bg-light bg-gradient">
                                            <h6 className="card-title mb-0 text-center" >My Attendance Report</h6>
                                        </div> */}
                                        <div className="row">
                                            <div className="card-header">
                                                <div className="row">
                                                    {/* <div style={{width:"20%"}} className='col-md-3'>
                                                        <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                                                    </div>
                                                    <div style={{width:"20%"}} className='col-md-3'>
                                                        <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                                                    </div> */}
                                                    <div className='col-md-3 position-relative mb-5'>
                                                        <div><label>Month</label></div>
                                                        <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                            <Select onChange={(selectOption) => this.setState({ month: selectOption?.value })}
                                                            options={this.state.monthOptions}
                                                            placeholder={`Select Month`}
                                                            value={ this.state.month ? this.state.monthOptions.find(option => option.value === this.state.month) : null}/>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3 position-relative mb-5'>
                                                        <div><label>Status</label></div>
                                                        <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                                            <Select onChange={(selectedOption) => this.handleSelectChange('selectOption', selectedOption)}
                                                            options={options}
                                                            placeholder={`Select Status`}
                                                            value={this.state.selectOption ? options.find(option => option.value === this.state.selectOption) : null}/>
                                                        </div>
                                                    </div>
                                                    {/* <div className='col-md-6'>
                                                        <div className="row"> */}
                                                    <div className='col-lg-2 col-md-3 col-6'>
                                                        <div><label>Apply Filter</label></div>
                                                        {/* <button onClick={this.handleInputSearch}
                                                            type="button"
                                                            // disabled={this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === ''}
                                                            className={` w-100 btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                                                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                            Filter
                                                        </button> */}
                                                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                                        disabled={!this.state.keyword && !this.state.month && !this.state.from_date && !this.state.to_date && !this.state.selectOption && !this.state.filter_leave_type_id}
                                                        loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                                        buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                                    </div>
                                                    <div className='col-lg-2 col-md-3 col-6'>
                                                        <div><label>Clear Filter</label></div>
                                                        {/* <button
                                                            type="button"
                                                            className={`w-100 btn btn-secondary btn-label waves-effect waves-light noWrap w-100 ${(!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}
                                                            onClick={this.handleClearAll}
                                                        >
                                                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 noWrap"></i> 
                                                        Clear</button> */}
                                                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                                        disabled={!this.state.keyword && !this.state.month && !this.state.from_date && !this.state.selectOption && !this.state.to_date && !this.state.filter_leave_type_id}
                                                        loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                                        buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                                    </div>
                                                    { this.state.decodedData?.includes(6) && ( 
                                                    <div className='col-lg-2 col-md-3 col-6'>
                                                        <div>
                                                            <label>Export Excel</label>
                                                        </div>
                                                        {/* <button
                                                            type="button"
                                                            onClick={this.handleExcelDownload}
                                                            className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light noWrap`}>
                                                            <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                            Export Excel
                                                        </button> */}
                                                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleExcelDownload() }} 
                                                        disabled={this.state.rows.length === 0}
                                                        buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                                    </div>)}
                                                        {/* </div>
                                                    </div> */}
                                                    {/* <div className='col-md-3'>
                                                        <div className="row">
                                                            <div className='col-md-12 mt-3'>
                                                                <div>
                                                                    <label>Export Excel</label>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    onClick={this.handleExcelDownload}
                                                                    className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-info btn-label waves-effect waves-light`}>
                                                                    <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                                    Export Excel
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div> */}
                                                </div>
                                            </div>
                                            <div ref={this.attendanceLocationInfoRef} className="mt-1" >
                                                {/* <div className="card-header">
                                                </div> */}
                                                {this.state.showLocation==="1" && (
                                                    <div className={`${this.state.punch_in_date || this.state.punch_out_date ? '' : 'd-none'} rounded-3 position-relative card-body grayBlurShadow mx-1`}>
                                                        <h6 className={`${this.state.punch_in_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center mt-md-0 mt-2 me-md-0 me-2`}>
                                                            <span className='bx bx-log-in fs-3' style={{ marginRight: "10px" }} />
                                                            <span>Punch In Date :: {this.state.punch_in_date} , Time :: {this.state.punch_in_time}</span>
                                                        </h6>
                                                        <h6 className={`${this.state.punch_out_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center mt-md-0 mt-2 me-md-0 me-2`}>
                                                            <span className='bx bx-log-out fs-3' style={{ marginRight: "10px" }} />
                                                            <span>Punch Out Date :: {this.state.punch_out_date} , Time :: {this.state.punch_out_time}</span>
                                                        </h6>
                                                        <h6 className={`card-title mb-3 d-flex align-items-center`}>
                                                            <span className='ri ri-map-pin-2-line fs-3' style={{ marginRight: "10px" }}></span>
                                                            <span>{this.state.punch_in_date === null ? (this.state.punch_out_address) : this.state.punch_in_address}</span>
                                                        </h6>
                                                        <span onClick={() => { this.setState({ showLocation: false }) }} style={{ right: "0.2rem", top: "0.2rem", cursor: "pointer" }} className=" position-absolute text-danger"><i className="ri-close-circle-line" style={{ fontSize: '26px' }}/></span>
                                                    </div>) 
                                                    // : (
                                                    // <div>
                                                    //     <div className="text-center mt-3">
                                                    //         <span className="text-info"><i className="mdi mdi-loading mdi-spin fs-1 align-middle me-2" /> Loading.....</span>
                                                    //     </div>

                                                    // </div>)
                                                    }

                                                {/* <div className='mt-3 '> */}
                                                {/* <MapContainer center={this.state.position} zoom={16} style={{ height: "550px" }} scrollWheelZoom={false}>

                                                        <TileLayer
                                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                        />
                                                        <Marker position={this.state.position}>
                                                            <Popup>
                                                                A pretty CSS3 popup. <br /> Easily customizable.
                                                            </Popup>
                                                        </Marker>
                                                    </MapContainer> */}
                                                {/* <Mapper position={[this.state.position[0], this.state.position[1]]} punchin={`${this.state.punch_in_time} ${this.state.punch_in_date}`} punchout={`${this.state.punch_out_time} ${this.state.punch_out_date}`} /> */}
                                                {/* </div> */}
                                            </div>
                                            <div className="col-lg-12 mt-4">
                                                <div className='card mt-3'>
                                                    <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                        <table style={{ minWidth: '100%' }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                            {/* <table className={`table table-borderless table-hover align-middle mb-0 table-bordered table-stripped`}> */}
                                                            <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                                                <tr className='text-center'>
                                                                    {/* <th>Sr.No.</th> */}
                                                                    <th>Date</th>
                                                                    <th>Punch In</th>
                                                                    <th>Punch Out</th>
                                                                    <th>Shift</th>
                                                                    <th className='noWrap'>Working Hours</th>
                                                                    {/* <th>Deviation</th> */}
                                                                    <th className='noWrap'>Attendance Status</th>
                                                                    {/* <th>Action</th> */}
                                                                    {/* <th className='noWrap'>Action Status</th>
                                                                    <th className='noWrap'>Regularization Type</th>
                                                                    <th>Reason</th>
                                                                    <th>Remark</th> */}
                                                                </tr>
                                                            </thead>
                                                            {this.state.rows.length === 0 ? (
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <NoRecords />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            ) : (
                                                                this.state.rows.map((row, idx) => (
                                                                    <tbody className='text-center'>
                                                                        <tr key={row.employee_attendance_id}>
                                                                            {/* <td className='text-center noWrap'>{idx + 1}</td> */}
                                                                            <td className='text-center noWrap'>{formatDate(row.attendance_date)}</td>
                                                                            <td>
                                                                                <div className=" d-flex flex-column gap-0 justify-content-start">
                                                                                    <span className='text-info d-flex justify-content-start  noWrap' style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {
                                                                                        if (row.punch_in_address) {
                                                                                            this.showInMap(row.punch_in_latlng, formatDate(row.PunchIn), formatTime(row.PunchIn), row.punch_in_address,"1");
                                                                                            this.scrollToDiv();
                                                                                        }
                                                                                    }}>
                                                                                        <span className='noWrap'>{formatDate(row.PunchIn)} {formatTime(row.PunchIn)}</span>
                                                                                    </span>
                                                                                    <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                        <small className=' noWrap'>{row.punch_in_address ? row.punch_in_address : row.PunchIn && !row.punch_in_address ? "Location is not captured." : "--"}</small>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td >
                                                                                <div className=" d-flex flex-column gap-0 justify-content-start">
                                                                                    <span className={`text-info d-flex justify-content-start  noWrap ${!row.PunchOut ? "d-none" : ""}`} style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {
                                                                                        if (row.punch_out_address) {
                                                                                            this.showOutMap(row.punch_out_latlng, formatDate(row.PunchOut), formatTime(row.PunchOut), row.punch_out_address,"1");
                                                                                            this.scrollToDiv();
                                                                                        }
                                                                                    }}>
                                                                                        <span className=' noWrap'>{formatDate(row.PunchOut)} {formatTime(row.PunchOut)}</span>
                                                                                    </span>
                                                                                    <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                        <small className=' noWrap'>{row.punch_out_address ? row.punch_out_address : row.PunchOut && !row.punch_out_address ? "Location is not captured." : "--"}</small>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className='noWrap'>{convertTo12HourFormat(row.ShiftStart)} - {convertTo12HourFormat(row.ShiftEnd)}</td>
                                                                            <td className='noWrap'>{row.WorkingHours ? getHoursAndMinutes(row.WorkingHours) : "--"}</td>
                                                                            {/* <td>
                                                                                <span className={isNegativeDeviation(getHoursAndMinutes(row.Deviation)) ? 'text-danger' : ''}>{row.Deviation ? getHoursAndMinutes(row.Deviation) : "--"}</span>
                                                                            </td> */}
                                                                            <td>
                                                                                {row.employee_leave_id ? (
                                                                                    <span className={`badge ${this.checkIsLeave(row) === " / 1" || this.checkIsLeave(row) === " / 2" ? this.calculateWorkingHours(row) ? "bg-warning" : "bg-danger" : "bg-success"}`}>
                                                                                        {this.checkIsLeave(row) === " / 1" || this.checkIsLeave(row) === " / 2"
                                                                                            ? this.calculateWorkingHours(row)
                                                                                                ? "Half Day"
                                                                                                : "Half Day Absent"
                                                                                            : `${row.leave_type_name}`}
                                                                                    </span>
                                                                                ) : row.calendar_festivals_name ? (
                                                                                    <span className="badge bg-secondary">
                                                                                        Holiday
                                                                                    </span>
                                                                                ) : row.ShiftWeekOff === "WeekOff" ? (
                                                                                    <span className={`badge bg-${row.ShiftWeekOffClasses}`}>
                                                                                        {row.ShiftWeekOff}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className={`badge bg-${row.AttendanceStatusClasses}`}>
                                                                                        {row.AttendanceStatus}
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            {/* <td>
                                                                                {row.attendance_status != 1 && <div className='d-flex justify-content-around'>

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-sm btn-outline-primary"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#exampleModalgrid"
                                                                                        onClick={() => this.setState({ employee_id: row.employee_id, employee_attendance_id: row.employee_attendance_id }, (prevState) => this.GetInfo())}
                                                                                    >
                                                                                        Regularize
                                                                                    </button>
                                                                                    <NavLink to={'/MyLeaves'}>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-success mx-3">
                                                                                            Leave
                                                                                        </button>
                                                                                    </NavLink>
                                                                                </div>}
                                                                            </td>
                                                                            <td></td> */}
                                                                            {/* <td ><span className={`badge bg-${row.regularizationRequestClasses}`}>{row.regularizationRequestStatus ? row.regularizationRequestStatus : "--"}</span></td>
                                                                            <td >{row.regularizationType}</td>
                                                                            <td className={`${row.remark_by_employee?.length >= 30 ? "textEllipse" : "noWrap"}`}>
                                                                                {row.remark_by_employee ? row.remark_by_employee : "--"}
                                                                            </td>
                                                                            <td className={`${row.remark_by_manager?.length >= 30 ? "textEllipse" : "noWrap"}`}>
                                                                                {row.remark_by_manager ? row.remark_by_manager : "--"}
                                                                            </td> */}
                                                                        </tr>

                                                                    </tbody>
                                                                ))
                                                            )}
                                                        </table>
                                                    </div>
                                                    {/* <div className="d-flex justify-content-between align-items-center w-100 p-2" >
                                                        <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                            {
                                                                <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                            }
                                                        </div>
                                                        <div className='col-md-2'>
                                                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                    <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                                {limitOptions.map((option) => (
                                                                    <option key={option} value={option}>
                                                                        Limit {option}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div>
                    </div >) : 
                    <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
        );
    }
}
export default withRouter(MyAttendanceReport);